import { createApp } from 'vue';
import consultantProgram from '../../components/consultants/consultantProgram'
import ActivityLogForm from '../../components/consultants/ActivityLogForm.vue'
import { createPinia } from 'pinia'

const pinia = createPinia();

if(document.getElementById('consultant-program-detail-container')){
    const app = createApp({
        components: {
            consultantProgram,
        }
    });
    app.use(pinia);
    app.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app.mount('#consultant-program-detail-container');
}

if(document.getElementById('activity-log-form-modal')){

    const app2 = createApp({
        components: {
            ActivityLogForm,
        }
    })
    
    app2.use(pinia)
    app2.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app2.mount('#activity-log-form-modal')
}